import { NativeDateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { Optional, Inject, Injectable } from '@angular/core';
import { Platform } from '@angular/cdk/platform';
import { formatDate } from '@angular/common';

@Injectable()
export class BitfDateAdapterService extends NativeDateAdapter {
  defaultFormat = 'yyyy-MM-dd';
  localeFormatMap = {
    it: 'dd/MM/yyyy',
  };
  firstDayMap = {
    it: 1,
    en: 7,
  };
  defaultFirstDay = 1;

  constructor(
    @Optional()
    @Inject(MAT_DATE_LOCALE)
    matDateLocale: string,
    platform: Platform
  ) {
    super(matDateLocale, platform);
  }

  format(date: Date): string {
    return formatDate(date, this.getFormat(), this.locale);
  }

  parse(value: string): Date | null {
    const format = this.getFormat();
    if (value.length !== format.length) {
      return null;
    }

    const ddIndex = format.indexOf('dd');
    const mMIndex = format.indexOf('MM');
    const yyyyIndex = format.indexOf('yyyy');

    const day = parseFloat(value.substr(ddIndex, 2));
    const month = parseFloat(value.substr(mMIndex, 2)) - 1;
    const year = parseFloat(value.substr(yyyyIndex, 4));

    const date = new Date();
    date.setDate(day);
    date.setMonth(month);
    date.setFullYear(year);

    return date;
  }

  private getFormat() {
    return this.localeFormatMap[this.locale] || this.defaultFormat;
  }

  getFirstDayOfWeek() {
    const lang = this.locale.substr(0, 2);
    return this.firstDayMap[lang] ? this.firstDayMap[lang] : this.defaultFirstDay;
  }
}
